const Footer = () => {
  return <footer>©2023 All Rights Reserved. Sysco Corporation</footer>;
};

export default Footer;
